import { defineFrontendModule } from '~/lib/module';

defineFrontendModule({
  name: 'navigation',
  owner: 'cella',
  scope: ['frontend'],
  description: 'Main navigation components including menus and sidebars.',
});
